import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

interface AlertRuleStatusCellProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const StatusBadge = styled.span<{ $status: string }>`
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ $status }) => {
    switch ($status) {
      case "active":
        return `
          color: #0f766e;
          border-color: #5eead4;
          background: #ecfeff;
        `
      case "inactive":
        return `
          color: #db2777;
          border-color: #f9a8d4;
          background: #fdf2f8;
        `
      default:
        return `
          color: var(--text-secondary);
          border-color: var(--border-strong);
          background: var(--surface-2);
        `
    }
  }}
`

export const AlertRuleStatusCell = ({ cell: { getValue } }: AlertRuleStatusCellProps) => {
  const status = getValue().value ? String(getValue().value) : ""

  return <StatusBadge $status={status}>{status.toUpperCase()}</StatusBadge>
}
